import React, {useMemo} from 'react';
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import {useSelector} from "react-redux";
import {EllipsisText, FlexColumnSection, FlexRowSection} from "../../../styles/globalStyles";
import {
    getMembershipAddons,
    getMembershipPriceText,
    selectTrackMembershipType,
} from "../../../helpers/functions";
import {t} from "i18next";

const TrackInfo = ({track}) => {
    const globalLocation = useSelector(state => state.site.selectedLocation)
    const box = useSelector(state => state.site.box)
    const {isMobile} = useScreenSize()
    const currencySymbol = useMemo(() => globalLocation?.currency_symbol, [globalLocation]);
    const membershipType = useMemo(() => selectTrackMembershipType(track), [track]);

    if (!track || !globalLocation) return <></>

    return (
        <FlexColumnSection gap={isMobile ? '10px' : '15px'} flex={'unset'}>
            <span>
                {getMembershipPriceText(membershipType, currencySymbol)} {membershipType?.addons?.length ? t(`for-hug-${membershipType.type}`) : ''}
                {membershipType?.addons?.length > 0 && <div>{getMembershipAddons(membershipType.addons, currencySymbol)}</div>}
                {membershipType?.max_installments > 1 && <div>{t('max-installments', {max_installments: membershipType.max_installments})}</div>}
            </span>
            {box?.locations_box?.length > 1 && <span>{t('location')}: {track.locations_box?.location}</span>}
        </FlexColumnSection>
    );
};

export default TrackInfo;
